"use strict";
/**
 * @module adaptive-expressions
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
class RegexErrorListener {
    syntaxError(_recognizer, // eslint-disable-line @typescript-eslint/no-unused-vars
    _offendingSymbol, // eslint-disable-line @typescript-eslint/no-unused-vars
    line, // eslint-disable-line @typescript-eslint/no-unused-vars
    charPositionInLine, // eslint-disable-line @typescript-eslint/no-unused-vars
    msg, // eslint-disable-line @typescript-eslint/no-unused-vars
    _e) {
        throw Error(`Regular expression is invalid.`);
    }
}
RegexErrorListener.Instance = new RegexErrorListener();
exports.RegexErrorListener = RegexErrorListener;
//# sourceMappingURL=regexErrorListener.js.map